// import varCommon from '@/utils/varCommon'
import { Notification } from 'element-ui';

export default {
  methods: {
    // 显示小数点
    formatDecimalSeparator(number, decimals) {
      return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
    },
    // 显示千分位分隔符和小数点
    formatNumberWithCommasAndDecimalSeparator(number, decimals = 0) {
      let num = this.formatDecimalSeparator(number, decimals)
      return this.NumberWithCommas(num)
    },
    // 移除物件内有空的资料
    ObjectClean(obj) {
      for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
          delete obj[propName];
        }
      }
      return obj
    },
    // 增加会计符号格式化
    NumberWithCommas(x) {
      var parts = x.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    /* 复制文字
     text 作为要复制的文本
     NotificMsg 如果有传则作为提示语(不直接显示复制的内容)
    */
    CopyTextToClipboard(text, NotificMsg) {
      if (!navigator.clipboard) {
        this.FallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function () {
        if (NotificMsg) {
          Notification({
            type: "error",
            message: NotificMsg,
          });
        } else {
          Notification({
            title: "已复制",
            message: text,
          });
        }
      }, function (err) {
        Notification({
          title: "复制失败",
          type: "error",
          message: err,
        });
      });
    },
    FallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? '成功' : '失败';
        Notification.success(`复制${msg}`);
      } catch (err) {
        Notification.error('复制失败: ', err);
      }
      document.body.removeChild(textArea);
    },
    // 浮点数相加
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    // 浮点数相减
    accSubtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) { r1 = 0 }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      n = (r1 >= r2) ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    // 浮点数相乘
    accMul(arg1, arg2) {
      if (arg1 !== undefined && arg2 !== undefined) {
        var m = 0;
        var s1 = arg1.toString();
        var s2 = arg2.toString();
        try {
          m += s1.split('.')[1].length;
        } catch (e) { () => { } }
        try {
          m += s2.split('.')[1].length;
        } catch (e) { () => { } }
        return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
      }
    },
    // 浮点数相除
    accDiv(arg1, arg2) {
      if (arg1 !== undefined && arg2 !== undefined) {
        var t1, t2, r1, r2;
        try {
          t1 = arg1.toString().split('.')[1].length;
        } catch (e) {
          t1 = 0;
        }
        try {
          t2 = arg2.toString().split('.')[1].length;
        } catch (e) {
          t2 = 0;
        }
        r1 = Number(arg1.toString().replace('.', ''));
        r2 = Number(arg2.toString().replace('.', ''));
        return this.accMul(r1 / r2, Math.pow(10, t2 - t1));
      }
    },
    HandleDeepCopy(row) {
      return JSON.parse(JSON.stringify(row))
    },
    // 将数字转为 W，例如 65000 = 6.5W
    formatToWan(val, len = 1) {
      return `${(val / 10000).toFixed(len)}W`;
    },
    /**
     * 生成唯一的 UUID（无 '-' 符号）。
     * @param {number} length - 需要的 UUID 长度，预设 32。
     */
    generateUUID(length = 32) {
      const uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11)
        .replace(/[018]/g, (c) =>
          (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
          ).toString(16)
        )
        .replace(/-/g, "");
      return uuid.slice(0, length);
    },
    // 可定义自己要输出的日期格式
    setDateFormat(date, format = "YYYY-MM-DD HH:mm:ss") {
      // 验证日期格式
      if (isNaN(date.getTime())) {
        return '无效日期格式';
      }
      // 如果不是 Date 格式，尝试转换
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      const pad = (n) => n.toString().padStart(2, '0');
      const map = {
        YYYY: date.getFullYear(),
        MM: pad(date.getMonth() + 1),
        DD: pad(date.getDate()),
        HH: pad(date.getHours()),
        mm: pad(date.getMinutes()),
        ss: pad(date.getSeconds()),
      };
      return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (key) => map[key]);
    },
    // 固定年化收益率百分比
    yearRatePercent(rate) {
      if (!rate) return 0;
      return (Math.floor(parseFloat(rate) * 100 * 1000) / 1000)
        .toString()
        .replace(/(\.\d*?)0+$/, "$1")
        .replace(/\.$/, "");
    },
    /**
     * 多个数值加减计算并格式化和无条件舍弃
     * @param {string|number|array} num - 输入的一个或多个数值（字符串或数字）
     * 使用：calcFormattedDecimal(['200.00', 300]), calcFormattedDecimal('200.00')
     * 
     * @param {Object} 
     * {
     *    mode: '+' | '-', // 计算模式："+" 表示相加，"-" 表示相减（从左到右）
     *    digits: number,  // 保留几位小数（使用无条件舍弃）
     *    comma: boolean,  // 是否格式化为千分位（默认 false）
     *    nonNegative: boolean // 是否负数一律转为 0
     * }
     * 
     * @returns {number|string} - 若 comma 为 true，返回字串
     */
    calcFormattedDecimal(num, {
      mode = '+',
      digits = 2,
      comma = false,
      nonNegative = false,
    } = {}) {
      const arr = Array.isArray(num) ? num : [num];

      const nums = arr.map(v => {
        const n = Number(v);
        return isNaN(n) ? 0 : n;
      });

      const factor = Math.pow(10, digits);

      let result = 0;
      if (nums.length === 1) {
        result = Math.floor(nums[0] * factor) / factor;
      } else {
        result = mode === '-'
          ? nums.reduce((acc, val) => acc - val)
          : nums.reduce((acc, val) => acc + val, 0);
        result = Math.floor(result * factor) / factor;
      }

      // 如果指定非负数，且结果为负，则强制转为 0
      if (nonNegative && result < 0) {
        result = 0;
      }

      return comma
        ? result.toLocaleString(undefined, {
          minimumFractionDigits: digits,
          maximumFractionDigits: digits
        })
        : result
    },
    /* 复制文字 for Mini app
     text 作为要复制的文本
    */
    async MiniAppCopyTextToClipboard(text) {
      if (!navigator.clipboard) {
        // 没有 clipboard API，使用备用方法
        return this.MiniAppFallbackCopyTextToClipboard(text);
      }

      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (err) {
        return this.MiniAppFallbackCopyTextToClipboard(text);
      }
    },
    MiniAppFallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // 避免页面滚动
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.opacity = "0";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      let successful = false;
      try {
        successful = document.execCommand('copy');
      } catch (err) {
        successful = false;
      }

      document.body.removeChild(textArea);
      return successful;
    },
  }
}


// WEBPACK FOOTER //
// ./src/utils/methodCommon.js